import { StatusTagProps } from '../../../../common/components/load-card/load-card-header/ILoadCardHeader';
import IWonOfferResponse from '../../../../common/interfaces/offers/IWonOfferResponse';
import i18n from '../../../../lib/i18n';
import WonOfferStatus from '../enums/won-offers-status.enum';

const offerStatusMap: Record<number, string> = {
    [WonOfferStatus.Confirmed]: 'Confirmada',
    [WonOfferStatus.Cancelled]: 'Cancelada',
    [WonOfferStatus.ConfirmedTms]: 'ConfirmadaTms',
};

export function getWonOfferTagStatusType(
    wonOffer: IWonOfferResponse,
): StatusTagProps {
    if (wonOffer.status === 'ClosedByTMS') {
        return {
            type: 'positive',
            id: 'won-offer-tag-confirmed-tms',
            dataTestId: 'won-offer-tag-confirmed-tms',
            label: i18n.t('SmartCargas.WonOffers.Tags.ConfirmedTms'),
        };
    }

    if (wonOffer.status === 'Closed') {
        if (wonOffer.loadStatus === 'ConfirmedTms') {
            return {
                type: 'positive',
                id: 'won-offer-tag-confirmed-tms',
                dataTestId: 'won-offer-tag-confirmed-tms',
                label: i18n.t('SmartCargas.WonOffers.Tags.ConfirmedTms'),
            };
        }

        return {
            type: 'positive',
            id: 'won-offer-tag-confirmed',
            dataTestId: 'won-offer-tag-confirmed',
            label: i18n.t('SmartCargas.WonOffers.Tags.Confirmed'),
        };
    }

    return {
        type: 'negative',
        id: 'won-offer-tag-cancelled',
        dataTestId: 'won-offer-tag-cancelled',
        label: i18n.t('SmartCargas.WonOffers.Tags.Cancelled'),
    };
}

export function getSelectOptionsEnumWonOfferStatus() {
    const options: any[] = [];

    const enumStrings = Object.keys(WonOfferStatus).filter(key =>
        Number.isNaN(Number(key)),
    );

    enumStrings.forEach((key: string) => {
        options.push({
            value: key,
            label: offerStatusMap[
                WonOfferStatus[key as keyof typeof WonOfferStatus]
            ],
        });
    });

    return options;
}
